import { Controller } from "@hotwired/stimulus";
import '@popperjs/core';
import * as tempusDominus from '@eonasdan/tempus-dominus';
import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.css';
import customDateFormat from '@eonasdan/tempus-dominus/dist/plugins/customDateFormat';
import { load, faFiveIcons } from '@eonasdan/tempus-dominus/dist/plugins/fa-five';
tempusDominus.extend(customDateFormat);
tempusDominus.extend(load);

function getMinDate(entradaValor) {
  const minDate = new Date(entradaValor);
  minDate.setDate(minDate.getDate() - 1);
  minDate.setHours(0, 0, 0, 0);
  return minDate;
}

function getToDay() {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return today;
}

function getMaxDate(salidaValor) {
  const maxDate = salidaValor ? new Date(salidaValor) : getToDay();
  maxDate.setHours(23, 59, 59, 999);
  return maxDate;
}


// Connects to data-controller="datepicker-range-limited"
export default class extends Controller {
  static values = {
    readonly: Boolean,
    entrada: String,
    salida: String
  }


  connect() {
    const entradaValor = this.entradaValue;
    const salidaValor = this.salidaValue;

    const minDate = getMinDate(entradaValor);
    const maxDate = getMaxDate(salidaValor);

    const datepickerConfig = {
      display: {
        components: {
          decades: true,
          year: true,
          month: true,
          date: true,
          hours: false,
          minutes: false,
          seconds: false,
        }
      },
      localization: {
        locale: 'es',
        format: 'dd/MM/yyyy'
      },
      allowInputToggle: true,
      restrictions: {
        minDate: minDate,
        maxDate: maxDate
      }
    };

    const td = new tempusDominus.TempusDominus(this.element, datepickerConfig);

    if (this.readonlyValue) td.disable();
  }
}
